import { render, staticRenderFns } from "./GrupoConductoresModalEdicion.vue?vue&type=template&id=2d30fd45&scoped=true&"
import script from "./GrupoConductoresModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./GrupoConductoresModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./GrupoConductoresModalEdicion.vue?vue&type=style&index=0&id=2d30fd45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d30fd45",
  null
  
)

export default component.exports